module.exports = __webpack_public_path__ + "media/35.283794a2.mp3";